<template>
  
  <div v-if="!isLoad" class="container vh-100 position-relative fake-slide mb-5">
    <div class="carousel-inner animated-background position-relative rounded">
      <div class="carousel-item btn-divide-left active">
        <div class="carousel-caption d-none d-md-block"></div>
      </div>
    </div>
    <div class="mt-5 w-100 d-flex justify-content-between">
      <div class="css-dom"></div>
      <div class="css-dom"></div>
      <div class="css-dom"></div>
      <div class="css-dom"></div>
    </div>
  </div>
  <main id="main" v-show="isLoad">
    <SlideView :slideshows="data.slideshows"/>
    <div class="mobile_search" style="margin-top: -25px; margin-bottom: 10px;">
      <SearchForm/>
    </div>
    <!-- <ClientView :partners="data.partner" /> -->
    <ServiceView :services="data.service" />
    <DownloadView :downloads="data.mobile_download"/>
    <ValueView :values="data.value" />
    <Contact :contact="data.contact" />
    <h1>{{ this.$checkLang }}</h1>
  </main>
   <!-- ======= Footer ======= -->
   <Footer :data="data.contact" :socials="data.social" />
    
    <!-- End Footer -->
</template>

<script>
// @ is an alias to /src
import SlideView from '@/views/HomePage/SlideView'
import ClientView from '@/views/HomePage/ClientView'
import ServiceView from '@/views/HomePage/ServiceView'
import DownloadView from '@/views/HomePage/DownloadView'
import ValueView from '@/views/HomePage/ValueView'
import Contact from '@/views/HomePage/Contact'
import Footer from '@/components/Footer'
import SearchForm from '@/components/SearchForm'

import axios from 'axios'
import { all } from '@/networks/all/index.service'
import { loadJs } from '@/components/inc/everythingJS/until'
// import language from "@/languages/lang";

export default {
  name: 'HomeView',
  props:{
    whereIs : {
      type : [String, Number],
      default : 'home'
    }
  },
  components: {
    SlideView,
    ClientView,
    ServiceView,
    DownloadView,
    ValueView,
    Contact,
    Footer,
    SearchForm
  },
  data(){
    return {
      data : [],
      isLoad : false,
      locale: localStorage.language
    }
  },
  methods:{
    async getData(){
      axios.get(all)
        .then((res)=>{
          if(res.status == 200){
            this.data = res.data.data;
            // console.log(res.data.data.);
            this.isLoad = true;
          }
        })
        .then(()=>{
          $('html, body').animate({
            scrollTop: $(`#${this.whereIs}`).offset().top - 100
          }, 20);
        })
        .catch((err) =>{
          console.log(err);
          // this.$swal(
          //   {
          //     icon: 'warning',
          //     title: err,
          //   }
          // )
        })
    }
  },
  async created(){
    await this.getData();
  },
  mounted(){
    $('.bi-x').trigger('click');
  },
  updated(){
    if(this.$route.name != 'register'){
      try{
        loadJs();
        const myCarouselElement = document.querySelector('#carouselExampleCaptions')
          const carousel = new bootstrap.Carousel(myCarouselElement, {
          interval: 2000,
          wrap: true
        })
        //  * Clients Slider
        //  */
        new Swiper('.clients-slider', {
          speed: 400,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          slidesPerView: 'auto',
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            320: {
              slidesPerView: 2,
              spaceBetween: 40
            },
            480: {
              slidesPerView: 3,
              spaceBetween: 60
            },
            640: {
              slidesPerView: 4,
              spaceBetween: 80
            },
            992: {
              slidesPerView: 6,
              spaceBetween: 120
            }
          }
        });
      
        // /**
        //  * Porfolio isotope and filter
        //  */
        window.addEventListener('load', () => {
          let portfolioContainer = select('.portfolio-container');
          if (portfolioContainer) {
            let portfolioIsotope = new Isotope(portfolioContainer, {
              itemSelector: '.portfolio-item',
              layoutMode: 'fitRows'
            });
      
            let portfolioFilters = select('#portfolio-flters li', true);
      
            on('click', '#portfolio-flters li', function(e) {
              e.preventDefault();
              portfolioFilters.forEach(function(el) {
                el.classList.remove('filter-active');
              });
              this.classList.add('filter-active');
      
              portfolioIsotope.arrange({
                filter: this.getAttribute('data-filter')
              });
              aos_init();
            }, true);
          }
      
        });
      
        // /**
        //  * Initiate portfolio lightbox 
        //  */
        const portfolioLightbox = GLightbox({
          selector: '.portfokio-lightbox'
        });
      
        /**
         * Portfolio details slider
         */
        new Swiper('.portfolio-details-slider', {
          speed: 400,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      } catch(err) {
        console.log(err);
        this.$swal(
          {
              icon: 'warning',
              title: err,
          }
        )
      }
    }
  }
}
</script>
<style>
.main-item {
  padding: 10px;
  background-color: #fff;
  width: 700px;
}

.background-masker {
  background-color: #fff;
  position: absolute;
}

.btn-divide-left {
  top: 0;
  left: 25%;
  height: 100%;
  width: 5%;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -800px 0
  }
  100% {
    background-position: 800px 0
  }
}

.animated-background {
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-color: #f8fafc;
  background: linear-gradient(to right, #f2efef 8%, #ececec 12%, #eceeee 33%);
  background-size: 800px 104px;
  height: 500px;
  position: relative;
}

.static-background {
  background-color: #f6f7f8;
  background-size: 800px 104px;
  height: 70px;
  position: relative;
  margin-bottom: 20px;
}

.shared-dom {
  width: 800px;
  height: 110px;
}
.sub-rect {
  border-radius: 100%;
  width: 70px;
  height: 70px;
  float: left;
  margin: 20px 20px 20px 0;
}
.pure-background {
  background-color: #eee;
}

.css-dom:empty {
  width: 280px;
  height: 220px;
  border-radius: 6px;
  box-shadow: 0 10px 45px rgba(0, 0, 0, .2);
  background-repeat: no-repeat;
  
  background-image:
    radial-gradient(circle 16px, lightgray 99%, transparent 0),
    linear-gradient(lightgray, lightgray),
    linear-gradient(lightgray, lightgray),
    linear-gradient(lightgray, lightgray),
    linear-gradient(lightgray, lightgray),
    linear-gradient(#fff, #fff); 
  
  background-size:
    32px 32px,
    200px 32px,
    180px 32px,
    230px 16px,
    100% 40px,
    280px 100%;
  
  background-position:
    24px 30px,
    66px 30px,
    24px 90px,
    24px 142px,
    0 180px,
    0 0;
}
.fake-slide{
  margin-top: 100px;
}
</style>
